<template>
  <div id="menu">
    <div class="menuBox">
      <div class="menuIcon" @click="showMenu=!showMenu"></div>
    </div>
    <transition enter-active-class="animate__animated animate__slideInLeft" leave-active-class="animate__animated animate__slideOutLeft">
      <van-collapse v-model="activeNames" v-show="showMenu" class="menuList">
        <van-collapse-item v-for="(f,idx) in formatMenu()" :key="idx" :title="f.name" :name="f.name" :is-link="!!f.secondList" :class="[!!f.secondList?'':'speItem']" @click.native.stop="ev_goPage(f.url,f.type)">
          <template #title>
            <div style="display:flex;align-items:center;">
              <div :class="['icon',activeNames.includes(f.name)?(f.activeClass):(f.class)]"></div>
              <div>{{f.name}}</div>
            </div>
          </template>
          <van-collapse v-model="activeNames" v-if="!!f.secondList">
            <van-collapse-item v-for="(s,sidx) in f.secondList" :key="sidx" :title="s.name" :name="s.name" :is-link="!!s.thirdList" :class="[!!s.thirdList?'':'speItem']" @click.native.stop="ev_goPage(s.url,s.type)">
              <van-collapse v-model="activeNames" v-if="!!s.thirdList">
                <van-collapse-item v-for="(t,tidx) in s.thirdList" :key="tidx" :title="t.name" :name="t.name" :is-link="!!t.fourthList" :class="[!!t.fourthList?'':'speItem']" @click.native.stop="ev_goPage(t.url,t.type)"></van-collapse-item>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </van-collapse-item>
      </van-collapse>
    </transition>
  </div>
</template>

<script>
import store from "@/store/index.js";
import { queryCurrentUser } from "@/http/index.js";
export default {
  name: "TopMenu",
  data() {
    return {
      showMenu: false,
      activeNames: ["1"],
      firstList: [
        {
          name: "首页",
          url: "/home",
          class: "homeIcon",
          activeClass: "sHomeIcon",
        },
        {
          name: "制度学习",
          class: "systemIcon",
          activeClass: "sSystemIcon",
          secondList: [
            {
              name: "制度列表",
              url: "/systemLearn/system",
            },
          ],
        },
        {
          name: "管理学习",
          class: "managerIcon",
          activeClass: "sManagerIcon",
          secondList: [
            {
              name: "视频课程",
              url: "/managerLearn/videoList",
              type: 1,
            },
            {
              name: "视频观看记录列表",
              url: "/managerLearn/videoRecordList",
              type: 1,
            },
            {
              name: "课程课件",
              url: "/managerLearn/courseWare",
              type: 1,
            },
            {
              name: "相关资料",
              url: "/managerLearn/relateData",
              type: 1,
            },
          ],
        },
        {
          name: "专业技能",
          class: "professIcon",
          activeClass: "sProfessIcon",
          secondList: [
            {
              name: "视频课程",
              url: "/professionalSkill/videoList",
              type: 2,
            },
            {
              name: "视频观看记录列表",
              url: "/professionalSkill/videoRecordList",
              type: 2,
            },
            {
              name: "课程课件",
              url: "/professionalSkill/courseWare",
              type: 2,
            },
            {
              name: "相关资料",
              url: "/professionalSkill/relateData",
              type: 2,
            },
          ],
        },
        {
          name: "营销技能",
          class: "marketIcon",
          activeClass: "sMarketIcon",
          secondList: [
            {
              name: "视频课程",
              url: "/marketSkill/videoList",
              type: 3,
            },
            {
              name: "视频观看记录列表",
              url: "/marketSkill/videoRecordList",
              type: 3,
            },
            {
              name: "课程课件",
              url: "/marketSkill/courseWare",
              type: 3,
            },
            {
              name: "相关资料",
              url: "/marketSkill/relateData",
              type: 3,
            },
          ],
        },
        {
          name: "通用技能",
          class: "generalIcon",
          activeClass: "sGeneralIcon",
          secondList: [
            {
              name: "视频课程",
              url: "/generalSkill/videoList",
              type: 4,
            },
            {
              name: "视频观看记录列表",
              url: "/generalSkill/videoRecordList",
              type: 4,
            },
            {
              name: "课程课件",
              url: "/generalSkill/courseWare",
              type: 4,
            },
            {
              name: "相关资料",
              url: "/generalSkill/relateData",
              type: 4,
            },
          ],
        },
        {
          name: "直播",
          class: "liveIcon",
          activeClass: "sLiveIcon",
          secondList: [
            {
              name: "观看直播",
              url: "/live/watchLive",
            },
            {
              name: "学习记录",
              url: "/live/studyRecord",
            },
          ],
        },
        {
          name: "优秀学师",
          class: "teacherIcon",
          activeClass: "sTeacherIcon",
          secondList: [
            {
              name: "匠才列表",
              url: "/teacher/craftsPerson",
            },
            {
              name: "讲师列表",
              url: "/teacher/teacherList",
            },
          ],
        },
        {
          name: "产品经理",
          class: "expertIcon",
          activeClass: "sExpertIcon",
          secondList: [
            {
              name: "专家列表",
              url: "/industryExpert/speciaList",
            },
          ],
        },
        {
          name: "人事任命",
          class: "appIcon",
          activeClass: "sAppIcon",
          secondList: [
            {
              name: "查看人事任命",
              url: "/appointmentLetter/appointmentLetterList",
            },
          ],
        },
        {
          name: "黑·库",
          class: "blackIcon",
          activeClass: "sBlackIcon",
          secondList: [
            {
              name: "信用黑名单",
              url: "/blackLibrary/creditBlacklist",
            },
            {
              name: "人才库",
              url: "/blackLibrary/personalInformation",
            },
          ],
        },
        {
          name: "服务",
          class: "serveIcon",
          activeClass: "sServeIcon",
          secondList: [
            {
              name: "办公室分布图",
              url: "/serve/officeMap",
            },
            {
              name: "行业发展报告",
              url: "/serve/industryReport",
            },
            {
              name: "团队列表",
              url: "/serve/teamList",
            },
            {
              name: "培训展示",
              thirdList: [
                {
                  name: "课程回顾",
                  url: "/serve/trainShow/courseReview",
                },
                {
                  name: "培训项目",
                  url: "/serve/trainShow/trainProject/trainProjectList",
                },
                {
                  name: "通知记录",
                  url: "/serve/trainShow/noticeRecord",
                },
              ],
            },
            {
              name: "人才招聘",
              url: "/serve/talentRecruitment",
            },
          ],
        },
        {
          name: "数字化月报",
          class: "szhybIcon",
          activeClass: "szhybBlueIcon",
          secondList: [
            {
              name: "本季度月报",
              url: "/digitalReport/current",
              minRank: 5,
            },
            {
              name: "历史提交",
              url: "/digitalReport/history",
              minRank: 5,
            },
            {
              name: "互学广场",
              url: "/digitalReport/plaza",
            },
          ],
        },
      ],
      userInfo: {},
    };
  },
  created() {
    this.getCurrentUserInfo();
  },
  computed: {
    formatMenu() {
      return () => {
        var list = [
          "制度学习",
          "直播",
          "优秀学师",
          "人事任命",
          "黑·库",
          "服务",
        ];
        const baseList = store.state.tryFlag
          ? this.firstList.filter((item) => list.indexOf(item.name) == -1)
          : this.firstList;
        return this.filterMenuByPermission(baseList);
      };
    },
  },
  methods: {
    getCurrentUserInfo() {
      queryCurrentUser().then((res) => {
        const data = res && res.data ? res.data : res;
        if (data.code == "0" && data.resultObj) {
          this.userInfo = data.resultObj;
        }
      });
    },
    parseRankNumber(rank) {
      const match = String(rank || "").toUpperCase().match(/M\s*(\d+)/);
      return match ? Number(match[1]) : -1;
    },
    hasMinRank(minRank) {
      return this.parseRankNumber(this.userInfo && this.userInfo.rank) >= minRank;
    },
    filterMenuByPermission(list) {
      return list
        .map((item) => {
          if (item.minRank && !this.hasMinRank(item.minRank)) return null;
          const nextItem = { ...item };
          if (item.secondList) {
            nextItem.secondList = this.filterMenuByPermission(item.secondList);
            if (!nextItem.secondList.length) return null;
          }
          if (item.thirdList) {
            nextItem.thirdList = this.filterMenuByPermission(item.thirdList);
            if (!nextItem.thirdList.length) return null;
          }
          if (item.fourthList) {
            nextItem.fourthList = this.filterMenuByPermission(item.fourthList);
            if (!nextItem.fourthList.length) return null;
          }
          return nextItem;
        })
        .filter(Boolean);
    },
    ev_goPage(path, type) {
      if (!path) {
        return;
      }
      this.$router.push({
        path: path,
        query: {
          date: new Date().getTime(),
          type,
        },
      });
      if (path) {
        this.showMenu = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
#menu {
  position: absolute;
  z-index: 100000000;
  width: 1.0666666667rem;
  top: 0;
  left: 0;
}
.menuBox {
  background-color: #498add;
  width: 100%;
  height: 64px;
  z-index: 1000000;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 0.32rem;
}
.menuIcon {
  width: 0.5333333333rem;
  height: 0.8rem;
  background: url("@/assets/menu.svg") no-repeat;
  background-size: cover;
}
.menuList {
  position: absolute;
  top: 64px;
  left: 0;
  width: 4.6933333333rem;
  z-index: 100000;
  height: calc(100vh - 64px);
  overflow: scroll;
  box-shadow: 0px 0px 5px 0px rgba(0, 59, 99, 0.25);
  background-color: #ffffff;
}
.secondLi {
  padding: 0.2666666667rem 0.4266666667rem;
}
.icon {
  margin-right: 0.3733333333rem;
}
.homeIcon {
  width: 0.4266666667rem;
  height: 0.3466666667rem;
  background: url("@/assets/menu/grayHome.svg") no-repeat;
  background-size: cover;
}
.sHomeIcon {
  width: 0.4266666667rem;
  height: 0.3466666667rem;
  background: url("@/assets/menu/blueHome.svg") no-repeat;
  background-size: cover;
}
.systemIcon {
  width: 0.3466666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/graySystem.svg") no-repeat;
  background-size: cover;
}
.sSystemIcon {
  width: 0.3466666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/blueSystem.svg") no-repeat;
  background-size: cover;
}

.managerIcon {
  width: 0.4266666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/grayManager.svg") no-repeat;
  background-size: cover;
}
.sManagerIcon {
  width: 0.4266666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/blueManager.svg") no-repeat;
  background-size: cover;
}

.professIcon {
  width: 0.3733333333rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/grayProfess.svg") no-repeat;
  background-size: cover;
}
.sProfessIcon {
  width: 0.3733333333rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/blueProfess.svg") no-repeat;
  background-size: cover;
}

.marketIcon {
  width: 0.4rem;
  height: 0.4rem;
  background: url("@/assets/menu/grayMarket.svg") no-repeat;
  background-size: cover;
}
.sMarketIcon {
  width: 0.4rem;
  height: 0.4rem;
  background: url("@/assets/menu/blueMarket.svg") no-repeat;
  background-size: cover;
}

.generalIcon {
  width: 0.4rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/grayGeneral.svg") no-repeat;
  background-size: cover;
}
.sGeneralIcon {
  width: 0.4rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/blueGeneral.svg") no-repeat;
  background-size: cover;
}

.teacherIcon {
  width: 0.4rem;
  height: 0.4266666667rem;
  background: url("@/assets/menu/grayTeacher.svg") no-repeat;
  background-size: cover;
}
.sTeacherIcon {
  width: 0.4rem;
  height: 0.4266666667rem;
  background: url("@/assets/menu/blueTeacher.svg") no-repeat;
  background-size: cover;
}

.expertIcon {
  width: 0.4266666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/industryExpert.svg") no-repeat;
  background-size: cover;
}
.sExpertIcon {
  width: 0.4266666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/industryExpertBlue.svg") no-repeat;
  background-size: cover;
}

.blackIcon {
  width: 0.4266666667rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/grayBlack.svg") no-repeat;
  background-size: cover;
}
.sBlackIcon {
  width: 0.4266666667rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/blueBlack.svg") no-repeat;
  background-size: cover;
}

.szhybIcon {
  width: 0.4266666667rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/szhyb.svg") no-repeat;
  background-size: cover;
}
.szhybBlueIcon {
  width: 0.4266666667rem;
  height: 0.4533333333rem;
  background: url("@/assets/menu/szhybBlue.svg") no-repeat;
  background-size: cover;
}

.liveIcon {
  width: 0.4rem;
  height: 0.4rem;
  background: url("@/assets/menu/grayLive.svg") no-repeat;
  background-size: cover;
}
.sLiveIcon {
  width: 0.4rem;
  height: 0.4rem;
  background: url("@/assets/menu/blueLive.svg") no-repeat;
  background-size: cover;
}

.appIcon {
  width: 0.4266666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/grayApp.svg") no-repeat;
  background-size: cover;
}
.sAppIcon {
  width: 0.4266666667rem;
  height: 0.4rem;
  background: url("@/assets/menu/blueApp.svg") no-repeat;
  background-size: cover;
}

.serveIcon {
  width: 0.4266666667rem;
  height: 0.4266666667rem;
  background: url("@/assets/menu/grayServe.svg") no-repeat;
  background-size: cover;
}
.sServeIcon {
  width: 0.4266666667rem;
  height: 0.4266666667rem;
  background: url("@/assets/menu/blueServe.svg") no-repeat;
  background-size: cover;
}

::v-deep .speItem .van-collapse-item__wrapper {
  display: none !important;
}
::v-deep .van-collapse-item__content {
  padding: 0 0.4266666667rem;
}
::v-deep .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: none;
}
</style>
